import styled from 'styled-components'

type IProps = {
  imageUrl: string
  title: string
}

const StyledTile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background: #fff;
  border-radius: 0.8rem;
  padding: 6rem 2.4rem 2.4rem;

  img {
    margin: auto 0;
  }
`

const StyledTitle = styled.h4`
  font-size: 0.02rem;
  font-family: 'Neue Montreal';
  font-size: 1.6rem;
  font-weight: 400;
  margin-top: 6.4rem;
`

const Tile = ({ imageUrl, title }: IProps) => (
  <StyledTile>
    <img src={imageUrl} alt={title} />
    <StyledTitle>{title}</StyledTitle>
  </StyledTile>
)

export default Tile
